import type { RouteRecordRaw } from 'vue-router';
import { EXPENSE_MANAGEMENT_TEXTS } from '../constants/expenseManagement.constant';
import { POLICY_TEXTS } from '../constants/policy.constant';
import { resolveExpenseManagementHomeRouteName } from '../utils/expenseManagementHome.util';
import {
  EXPENSE_MANAGEMENT_ROUTE_NAMES,
  EXPENSE_MANAGEMENT_ROUTE_PATHS,
} from '@/shared/common/constants/expenseManagementRoutes.constant';

const MainLayout = () => import('@/shared/layouts/pages/MainLayout/index.vue');
const SubmitterHome = () => import('@/modules/expenseManagement/pages/SubmitterHome/index.vue');
const ApproverHome = () => import('@/modules/expenseManagement/pages/ApproverHome/index.vue');
const AdministratorHome = () =>
  import('@/modules/expenseManagement/pages/AdministratorHome/index.vue');
const PolicyList = () => import('@/modules/expenseManagement/pages/PolicyList/index.vue');

export const expenseManagementRoutes: Array<RouteRecordRaw> = [
  {
    path: EXPENSE_MANAGEMENT_ROUTE_PATHS[EXPENSE_MANAGEMENT_ROUTE_NAMES.HOME],
    component: MainLayout,
    meta: {
      flag: 'feature_expense_management',
    },
    children: [
      {
        path: '',
        name: EXPENSE_MANAGEMENT_ROUTE_NAMES.HOME,
        redirect: () => ({ name: resolveExpenseManagementHomeRouteName() }),
      },
      {
        path: EXPENSE_MANAGEMENT_ROUTE_PATHS[EXPENSE_MANAGEMENT_ROUTE_NAMES.SUBMITTER],
        name: EXPENSE_MANAGEMENT_ROUTE_NAMES.SUBMITTER,
        component: SubmitterHome,
        meta: {
          requiresAuth: true,
          title: EXPENSE_MANAGEMENT_TEXTS.SUBMITTER_TITLE,
        },
      },
      {
        path: EXPENSE_MANAGEMENT_ROUTE_PATHS[EXPENSE_MANAGEMENT_ROUTE_NAMES.APPROVER],
        name: EXPENSE_MANAGEMENT_ROUTE_NAMES.APPROVER,
        component: ApproverHome,
        meta: {
          requiresAuth: true,
          title: EXPENSE_MANAGEMENT_TEXTS.APPROVER_TITLE,
        },
      },
      {
        path: EXPENSE_MANAGEMENT_ROUTE_PATHS[EXPENSE_MANAGEMENT_ROUTE_NAMES.ADMINISTRATOR],
        component: AdministratorHome,
        meta: {
          requiresAuth: true,
          title: EXPENSE_MANAGEMENT_TEXTS.ADMINISTRATOR_TITLE,
        },
        children: [
          {
            path: '',
            name: EXPENSE_MANAGEMENT_ROUTE_NAMES.ADMINISTRATOR,
            redirect: { name: EXPENSE_MANAGEMENT_ROUTE_NAMES.POLICIES },
          },
          {
            path: EXPENSE_MANAGEMENT_ROUTE_PATHS[EXPENSE_MANAGEMENT_ROUTE_NAMES.POLICIES],
            name: EXPENSE_MANAGEMENT_ROUTE_NAMES.POLICIES,
            component: PolicyList,
            meta: {
              requiresAuth: true,
              title: POLICY_TEXTS.TITLE,
            },
          },
        ],
      },
    ],
  },
];
